import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUi from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import BaiduMap from 'vue-baidu-map'
import productJSON from './assets/product.json'
import newsJSON from './assets/news.json'


Vue.prototype.productJSON = productJSON
Vue.prototype.newsJSON = newsJSON

Vue.use(BaiduMap,{
  ak:'qDU37UwaFhRlYVVbGINjAgnrFpFRfWfM'
})

Vue.use(ElementUi, {
  size:'mini'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')